import { Toast as BaseToast, type ToastObject } from '@base-ui/react';

import type { ToastObjectOverrides } from '~/utils/toast';

import { Toast } from './Toast';
import { viewportStyle } from './ToastViewport.css';

export const ToastViewport = () => {
  const { toasts } = BaseToast.useToastManager();

  return (
    <BaseToast.Viewport className={viewportStyle}>
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast as ToastObject<never> & ToastObjectOverrides} />
      ))}
    </BaseToast.Viewport>
  );
};
